module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'pd4vrxjx',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}